document.addEventListener('DOMContentLoaded', () => {

  const cartForm =
    document.querySelector('#CartForm');

  if (!cartForm) return;


  const updateButton =
    cartForm.querySelector(
      'button[name="update"]'
    );

  if (!updateButton) return;


  /*
   * CHANGE ONE CART LINE
   *
   * cart/change.js validates requested quantities
   * against Shopify inventory.
   */

  async function changeCartLine(
    cartKey,
    quantity
  ) {

    const response = await fetch(
      window.Shopify.routes.root + 'cart/change.js',
      {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },

        body: JSON.stringify({
          id: cartKey,
          quantity: quantity
        })
      }
    );


    if (!response.ok) {

      let message =
        'Unable to update this item.';

      try {

        const errorData =
          await response.json();

        console.error(
          'Shopify cart change error:',
          errorData
        );

        if (errorData.description) {
          message =
            errorData.description;
        }

      } catch (parseError) {

        console.error(
          'Unable to read Shopify cart error:',
          parseError
        );

      }

      throw new Error(message);
    }


    return response.json();
  }


  /*
   * UPDATE CART
   */

    /*
    * REMOVE BUTTONS
    *
    * Set the jewellery quantity to zero and use
    * the existing Update Cart process.
    *
    * This means paired Edison upgrades continue
    * to use the exact same safe removal logic.
    */

    const removeButtons =
      cartForm.querySelectorAll(
        '[data-cart-remove]'
      );

    removeButtons.forEach((button) => {

      button.addEventListener(
        'click',
        () => {

          const product =
            button.closest(
              '[data-cart-line]'
            );

          if (!product) return;

          const quantityInput =
            product.querySelector(
              '[data-cart-quantity]'
            );

          if (!quantityInput) return;

          quantityInput.value = 0;

          updateButton.click();

        }
      );

    });

  updateButton.addEventListener(
    'click',
    async (event) => {

      event.preventDefault();


      const originalButtonText =
        updateButton.textContent;


      updateButton.disabled = true;
      updateButton.textContent =
        'Updating...';


      try {

        const jewelleryInputs =
          Array.from(
            cartForm.querySelectorAll(
              '[data-cart-quantity]'
            )
          );


        /*
         * Process each jewellery line separately.
         */

        for (const input of jewelleryInputs) {

          const cartKey =
            input.dataset.cartKey;

          const pairId =
            input.dataset.edisonPair || '';

          const requestedQuantity =
            Math.max(
              0,
              Number(input.value) || 0
            );


          /*
           * IMPORTANT:
           *
           * Find the linked Edison upgrade BEFORE
           * changing the cart.
           *
           * Shopify can change cart state after a
           * line is modified, so we capture the
           * upgrade key while both lines still exist.
           */

          let edisonCartKey = null;


          if (pairId) {

            const edisonRow =
              cartForm.querySelector(
                `[data-edison-pair="${CSS.escape(pairId)}"][data-edison-upgrade]`
              );


            if (edisonRow) {
              edisonCartKey =
                edisonRow.dataset.cartKey;
            }

          }


          /*
           * REMOVING AN EDISON PIECE
           *
           * Remove the upgrade FIRST.
           *
           * Then remove the jewellery.
           *
           * This prevents an $18 Edison upgrade
           * being left behind as an orphan.
           */

          if (
            requestedQuantity === 0 &&
            edisonCartKey
          ) {

            await changeCartLine(
              edisonCartKey,
              0
            );


            await changeCartLine(
              cartKey,
              0
            );


            continue;
          }


          /*
           * NORMAL JEWELLERY UPDATE
           *
           * Update the jewellery first so Shopify
           * validates its actual inventory.
           */

          await changeCartLine(
            cartKey,
            requestedQuantity
          );


          /*
           * If this jewellery has an Edison upgrade,
           * keep its quantity matched.
           */

          if (edisonCartKey) {

            await changeCartLine(
              edisonCartKey,
              requestedQuantity
            );

          }

        }


        /*
         * Everything succeeded.
         */

        window.location.reload();


      } catch (error) {

        console.error(
          'Cart quantity update error:',
          error
        );


        updateButton.disabled = false;

        updateButton.textContent =
          originalButtonText ||
          'Update cart';


        const message =
          String(
            error.message || ''
          ).toLowerCase();


        if (
          message.includes('maximum') ||
          message.includes('quantity') ||
          message.includes('inventory') ||
          message.includes('stock') ||
          message.includes('availability') ||
          message.includes('only')
        ) {

          alert(
            'We don’t have enough of this piece available for that quantity. Please reduce the quantity and try again.'
          );

        } else {

          alert(
            'There was a problem updating your cart. Please try again.'
          );

        }

      }

    }
  );

});